export const APP_ROUTE_MAIN_PATHS = {
    BRAND: '/:brand',
    SEARCH: '/search',
    // PUBLIC routes
    HEALTH_CHECK: '/health/live',
  };